import { CircleAlert } from "lucide-react";

type Props = {
  className?: string;
  children: React.ReactNode;
};

export default function Warning({ className, children }: Props) {
  return (
    <div
      className={`p-2 border border-[--color-alert-warning-accent] bg-[--color-alert-warning-background] rounded-md flex gap-1.5 ${className || ""}`}
    >
      <div>
        <CircleAlert className="h-4 w-4 text-[--color-alert-warning-accent]" />
      </div>
      <div className="text-xs text-[--color-text-primary]">{children}</div>
    </div>
  );
}
